var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pub-divider"},[_c('a-divider',{attrs:{"orientation":_vm.orientation}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }